function deferFilterjQuery() {
    if (window.jQuery) {
        var $ = window.jQuery;
        $(function(){
          // On load/reload
          var pt_on_load = function() {
            // Accordion
            

            // Search
            $('.pt-display-search').not('.has_group_selected').find('input.fm-search-box').show();

            // Drop downs
            $('.pt-display-dropdown').each(function( index ) {
                $(this).find('h4').after($(this).find('.filter-clear'));
            });

            $('.pt-display-dropdown .scroll-content').each(function( index ) {
                if($(this).parent().find('.menu-trigger').length === 0) {
                    if($(this).find('li.selected').length) {
                        var selected = $.map(
                            $(this).find('li.selected a'),
                                function(element){
                                    return $(element).text();
                                }
                        ).join(", ");

                        if (selected.length < 30) {
                            $(this).before('<div class="menu-trigger">' + selected +'</div>');
                        } else {
                            $(this).before('<div class="menu-trigger">' + $(this).find('li.selected').length + ' Selected </div>');
                        }
                    }
                    else {
                        $(this).before('<div class="menu-trigger">'+ $(this).closest('.filter-group').find('h4').text() +'</div>');
                    }
                }
            });

            //Sticky Mode
             // end sticky enable

            // View more
            

            $('.filter-menu li a').each(function() {
             var $a = $(this),
                 isSelected = $a.closest('li').hasClass('selected'),
                  label = (isSelected ? "Clear filter: " : "Add filter: ")
                          + $a.text().replace(/\s+/g, ' ').trim();

              $a.attr('title', label).attr('aria-label', label);

              if (isSelected) {
                $a.attr('aria-current', 'true');
              } else {
                $a.removeAttr('aria-current');
              }
            });

             // a11y: the mobile filter toggle is a disclosure, but it
            // ships as a plain <a href="#"> with no state. Without these it
            // announces as a link and never reports whether the panel is open.
            //
            // Set here rather than in the template because .filter-menu is
            // REPLACED wholesale by the apply-button path below
            // ($('.filter-menu').replaceWith(elem)) and by pjax, which would
            // discard anything applied once at startup. pt_on_load re-runs
            // after both -- the same reason the aria-current block above sits
            // here.
            //
            // The id is assigned here too, because the server markup has none
            // and a replaced .filter-menu arrives without it.
            $('.filter-menu').each(function (i) {
              var $menu = $(this);
              var $toggle = $menu.find('.pt-mobile-header a');

              if (!$toggle.length) return;

              if (!$menu.attr('id')) {
                $menu.attr('id', 'FilterMenu' + (i > 0 ? '-' + i : ''));
              }

              // Read the current state rather than assuming closed: pt_on_load
              // runs again after a filter is applied, when the panel may
              // already be expanded.
              $toggle
                .attr('aria-controls', $menu.attr('id'))
                .attr('aria-expanded', $menu.hasClass('pt-expand') ? 'true' : 'false');
            });

            // a11y: the clear-filter controls live outside the <li> list, so
            // the labelling block above misses them. Their only text is
            // "clear" at font-size 0 -- a genuine accessible name, but it
            // does not say what it clears.
            $('.filter-menu .filter-clear').each(function () {
              var $a = $(this);
              var group = $a.closest('.filter-group').find('h4').first().text().replace(/\s+/g, ' ').trim();
              var label = group ? 'Clear ' + group + ' filters' : 'Clear filters';

              $a.attr('aria-label', label).attr('title', label);
            });

            // a11y (N-38, 2.1.1): the group headings ARE the accordion
            // controls -- the theme binds a click on them that slides the
            // group's .scroll-content open and adds .select to the heading --
            // but an <h4> is not focusable, so there was no keyboard route to
            // them at all. Measured on a fresh /collections/all: all three
            // groups ship collapsed, and a collapsed .scroll-content is
            // display:none, so every facet on the page was unreachable.
            //
            // The control becomes a real <button> nested INSIDE the <h4>
            // rather than a role/tabindex on the <h4> itself. These headings
            // are the collection page's only headings below the <h1>, so
            // converting them would have traded heading navigation for button
            // semantics; nesting keeps both. The theme's own handler is
            // untouched: it is bound to the <h4>, and the button's click
            // bubbles to it.
            //
            // NOT wrapped in {% if settings.pt_accordion_enable %}: that setting
            // is OFF on this store, so the app's own accordion code is
            // stripped at compile time and never runs. The expand/collapse
            // behaviour belongs to the THEME, so this has to emit
            // unconditionally. Verified against the deployed asset -- it
            // contains no 'pt-group-expanded' at all.
            $('.filter-menu .filter-group')
              .not('.refine-header, .pt-display-dropdown')
              .each(function (i) {
                var $group = $(this);
                var $h4 = $group.find('h4').first();
                var $panel = $group.find('.scroll-content').first();

                // A group with no panel is a heading, not a control. This is
                // what keeps the "Refine" header a plain heading rather than
                // a button that does nothing.
                if (!$h4.length || !$panel.length) return;
                if ($h4.find('.filter-group-toggle').length) return;

                // Read the label before emptying the heading.
                var label = $h4.text().replace(/\s+/g, ' ').trim();

                // The app already ids each panel ("COLLECTIONS", "SIZE",
                // "BRAND"); only fall back if one arrives without.
                var panelId = $panel.attr('id');
                if (!panelId) {
                  panelId = 'FilterPanel-' + i;
                  $panel.attr('id', panelId);
                }

                var $btn = $('<button/>', {
                  type: 'button',
                  'class': 'filter-group-toggle',
                  'aria-controls': panelId,
                  text: label
                });

                $h4.empty().append($btn);

                // State is read from the panel's RESOLVED display, not from a
                // class: the theme opens it with a jQuery slide, which writes
                // an inline style, and a group can also arrive open from the
                // server -- on /collections/all/nike, COLLECTIONS and the
                // selected BRAND group both render expanded.
                var btn = $btn[0];
                var panel = $panel[0];
                var sync = function () {
                  var want = window.getComputedStyle(panel).display === 'none' ? 'false' : 'true';
                  if (btn.getAttribute('aria-expanded') !== want) {
                    btn.setAttribute('aria-expanded', want);
                  }
                };

                sync();

                // Observed rather than written on click. slideDown sets
                // display:block at the START of the animation, but slideUp
                // only sets display:none at the END -- so anything that reads
                // the panel on a timer after the click reports "open" while it
                // is still closing, and the control would announce the wrong
                // state on every collapse. The observer fires when the value
                // actually lands, whatever drives it.
                if (window.MutationObserver) {
                  new MutationObserver(sync).observe(panel, {
                    attributes: true,
                    attributeFilter: ['style', 'class']
                  });
                }
              });

            // Handle nested filters
            var splitPath = function(url) {
              var splitUrl =  url.split('?')[0].split('#')[0].split('/');
              return splitUrl;
            }

            var getCollection = function(url) {
              var splitUrl = splitPath(url);
              return splitUrl[2];
            }

            var getTags = function(url) {
              var splitUrl = splitPath(url);
              return (splitUrl[3] || '').split('+');
            }

            var getCommonCollection = function(url_top, url_nested) {
              var collection_top = getCollection(url_top);
              var collection_nested = getCollection(url_nested);
              if (collection_top !== collection_nested) {
                return 'all';
              }
              return collection_top;
            }

            var getCommonTags = function(url_top, url_nested) {
              var tags_top = getTags(url_top);
              var tags_nested = getTags(url_nested);

              return tags_top.filter(function(n) {
                return tags_nested.indexOf(n) > -1;
              });
            }

            var getCommonUrl = function(url_top, url_nested) {
              var val = '/collections/' + getCommonCollection(url_top, url_nested) + '/' + getCommonTags(url_top, url_nested).join('+');

              var lastChar = val.slice(-1);
                    if (lastChar == '/') {
                    val = val.slice(0, -1);
                }

              return val;
            }

            var clearNestedParent = $('.pt-display-nested').prev().each(function() {
              var clearNested = $(this).next().find('a.filter-clear').attr('href');
              if (!clearNested) return;
              var clearLink = $(this).find('a.filter-clear');
              clearLink.attr('href', getCommonUrl(clearLink.attr('href'), clearNested))
              var filterLinks = $(this).find('li.selected .collection-name a').each(function() {
                $(this).attr('href', getCommonUrl($(this).attr('href'), clearNested))
              })
            })
          }

          pt_on_load();

          // Mobile filter button
          
          $(document).on('click', '.filter-menu .pt-mobile-header a', function(e){
            if(e.handled !== true) {
              var $toggle = $('.pt-nav-toggle');
              var willExpand = !$toggle.hasClass('active');

              if (willExpand) {
                $('.filter-menu').addClass('pt-expand');
              } else {
                $('.filter-menu').removeClass('pt-expand');
                $('.pt-display-dropdown .scroll-content').hide();
              }

              $toggle.toggleClass('active');

              // a11y (N-21): keep the announced state in step with the
              // class-based state. Derived from willExpand rather than
              // re-reading the class, because toggleClass has already run.
              $toggle.attr('aria-expanded', willExpand ? 'true' : 'false');

              e.preventDefault();
              e.handled = true;
            }
          });
          

          // Accordion
          

          // Search
          $(document).on('keyup', '.filter-group input.fm-search-box', function () {
            var value = this.value.toLowerCase();
            $(this).closest('.filter-group').find('li').each(function () {
              if ($(this).text().toLowerCase().search(value) > -1) {
                $(this).show(100);
              } else {
                $(this).hide(100);
              }
            });
          });

          // Drop downs
          $(document).on('click','.pt-display-dropdown .menu-trigger',function() {
            $(this).next('.scroll-content').css('top', $(this).position().top + $(this).height() + 1).css('left', $(this).position().left);
            $(this).next('.scroll-content').slideToggle('fast');
          });

          $(document).on('mouseleave', '.pt-display-dropdown .scroll-content', function() {
            $(this).slideUp('fast');
          });

          // Apply button
          

          // Ajax
          
      });
    }
    else {
        setTimeout(function() { deferFilterjQuery() }, 50);
    }
}

deferFilterjQuery();
